import React from 'react';
import Modal from '../../shared/components/Modal';
import { PlatformRateRow } from './api';

const SOURCES: { key: 'binance' | 'bybit' | 'okx'; label: string }[] = [
  { key: 'binance', label: 'Binance' },
  { key: 'bybit', label: 'ByBit' },
  { key: 'okx', label: 'OKX' },
];

const formatRate = (value: number | string | null) => {
  const num = value != null ? Number(value) : null;
  if (num === null || !Number.isFinite(num)) return null;
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  });
};

interface PlatformRateDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  row: PlatformRateRow | null;
  sourcesUsed: string[];
}

const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div>
    <p className="text-xs text-slate-500 mb-1">{label}</p>
    <div className="text-slate-200">{children}</div>
  </div>
);

const PlatformRateDetailModal: React.FC<PlatformRateDetailModalProps> = ({
  isOpen,
  onClose,
  row,
  sourcesUsed,
}) => {
  if (!row) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`${row.currency} rate`} size="md">
      <div className="space-y-4">
        <Field label="Currency">
          <span className="text-white font-semibold text-lg">{row.currency}</span>
        </Field>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {SOURCES.map(({ key, label }) => {
            const formatted = formatRate(row[key]);
            const live = sourcesUsed.includes(key);
            return (
              <Field key={key} label={label}>
                {formatted !== null ? (
                  <span className="font-mono">
                    {formatted} <span className="text-xs text-slate-500">USD</span>
                  </span>
                ) : (
                  <span className="text-slate-500">—</span>
                )}
                <p className={`text-xs mt-1 ${live ? 'text-emerald-400' : 'text-red-400'}`}>
                  {live ? 'Live' : 'Unavailable'}
                </p>
              </Field>
            );
          })}
        </div>

        <Field label="Platform rate (average)">
          {formatRate(row.average) !== null ? (
            <span className="font-mono text-indigo-300 font-semibold text-lg">
              {formatRate(row.average)} <span className="text-xs text-slate-500 font-normal">USD</span>
            </span>
          ) : (
            <span className="text-slate-500">—</span>
          )}
        </Field>
      </div>
    </Modal>
  );
};

export default PlatformRateDetailModal;
